<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" title="Dedcation">
<p class="fmh1" id="ded"><span class="right_1" epub:type="pagebreak" id="page_v" title="v"><a href="#/text/9780802156969_Contents#rded">DEDCATION</a></span></p>
<p class="dedt">To</p>
<p class="dedt"><i>The Distler IV</i></p>
<p class="dedt">Joseph</p>
<p class="dedt">Nancy</p>
<p class="dedt">Emma</p>
<p class="ded0">Morgan<span class="right_1" epub:type="pagebreak" id="page_vi" title="vi"></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780802156969_Dedcation.vue?47f01528